import { NavItemType } from '@types';

import { sidebarMenuItems } from '@widgets/sidebar-menu-items';

export const MENU_ITEMS: { items: NavItemType[] } = {
  items: [sidebarMenuItems],
};
